import { getTranslatedString } from 'helpers/i18n';
import { Archived, Draft, Published } from './constants';
import { ButtonGroup } from '@yuhuinc/ui-library';

const ActionButtons = ({
  form,
  loading,
  onCreate,
  onUpdate,
  onArchive,
  onPublish,
  onRepublish,
  onDelete,
}) => {
  const { status, id } = form.values;
  const buttons = [];

  const validateForm = async (form) => {
    const errors = await form.validateForm();

    if (Object.keys(errors).length === 0) {
      return [true];
    }

    form.setTouched(Object.fromEntries(Object.keys(errors).map((field) => [field, true])));

    return [false, errors];
  };

  const handleCreateOrUpdate = async () => {
    const [isValid] = await validateForm(form);

    if (isValid) {
      const { values } = form;

      if (values.id) {
        await onUpdate(values, values.id);
      } else {
        await onCreate(values);
      }
    }
  };

  const handlePublish = async () => {
    const [isValid] = await validateForm(form);

    if (isValid) {
      const { values } = form;

      await onPublish({ ...values, status: Published });
    }
  };

  const handleDelete = async () => {
    const { values } = form;
    await onDelete(values.id);
  };

  const handleArchive = async () => {
    const [isValid] = await validateForm(form);

    if (isValid) {
      const { values } = form;

      await onArchive({ ...values, status: Archived });
    }
  };

  const handleRepublish = async () => {
    const [isValid] = await validateForm(form);

    if (isValid) {
      const { values } = form;

      await onRepublish({ ...values, status: Published });
    }
  };

  if (status === Draft) {
    buttons.push(
      onDelete &&
        id && {
          label: getTranslatedString('landlordPortal.incentives.delete'),
          onClick: handleDelete,
        },
      (onCreate || onUpdate) && {
        label: getTranslatedString('landlordPortal.incentives.saveAsDraft'),
        onClick: handleCreateOrUpdate,
        loading,
      },
      onPublish && {
        label: getTranslatedString('landlordPortal.incentives.publish'),
        onClick: handlePublish,
      }
    );
  } else if (status === Published) {
    buttons.push(
      onDelete && {
        label: getTranslatedString('landlordPortal.incentives.delete'),
        onClick: handleDelete,
      },
      onArchive && {
        label: getTranslatedString('landlordPortal.incentives.archive'),
        onClick: handleArchive,
      },
      (onCreate || onUpdate) && {
        label: getTranslatedString('landlordPortal.incentives.save'),
        onClick: handleCreateOrUpdate,
        loading,
      }
    );
  } else if (status === Archived) {
    buttons.push(
      (onCreate || onUpdate) && {
        label: getTranslatedString('landlordPortal.incentives.save'),
        onClick: handleCreateOrUpdate,
        loading,
      },
      onRepublish && {
        label: getTranslatedString('landlordPortal.incentives.republish'),
        onClick: handleRepublish,
      }
    );
  }

  return <ButtonGroup buttons={buttons.filter(Boolean)} />;
};

export default ActionButtons;
